import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface StatusChangePopupData {
  action: string;
  title: any;
  type: string;
  secondaryButtonText?: string;
}

@Component({
  selector: 'app-status-change-popup',
  standalone: false,
  templateUrl: './status-change-popup.html',
  styleUrl: './status-change-popup.scss'
})
export class StatusChangePopup {

  action: string;
  title: string;
  type: string;
  secondaryButtonText: string;

  constructor(
    private readonly dialogRef: MatDialogRef<StatusChangePopup>,
    @Inject(MAT_DIALOG_DATA) public data: StatusChangePopupData) {
    this.action = data?.action;
    this.title = data?.title;
    this.type = data?.type;
    this.secondaryButtonText = data?.secondaryButtonText || 'No';
  }

  close() {
    this.dialogRef.close(false);
  }

  onSecondaryButtonClick() {
    if (this.secondaryButtonText === 'Edit') {
      this.dialogRef.close('edit');
    } else {
      this.dialogRef.close(false);
    }
  }

  confirmStatusChange() {
    this.dialogRef.close(true);
  }
}